import { PathsElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class Paths extends PathsElement {}
export default Paths;